import React from 'react';

// AEO answer snippet: a 40–60 word direct answer placed right under the H1, so answer
// engines and featured snippets can lift it. Referenced by the BlogPosting `speakable` selector.
export default function QuickAnswer({ text, label = 'Σύντομη απάντηση' }) {
  if (!text) return null;
  return (
    <div
      id="quick-answer"
      className="text-left bg-ivory border-l-4 border-gold rounded-card-sm px-6 py-5 mb-7 shadow-card-soft"
    >
      <div className="text-eyebrow uppercase tracking-wider text-gold font-semibold mb-2">{label}</div>
      <p className="text-body-l text-warm-black leading-[1.6] m-0">{text}</p>
    </div>
  );
}